import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import Page from 'components/layouts/page/Page';
import Button from 'components/shared/Button';
import { colors } from 'styles/theme/colors';
import { Body } from 'styles/typography';
import CircleCheckIcon from 'svg/CircleCheckIcon';

type LocationState = { customerName?: string };

export default function CoordinateRequestSubmittedPage() {
  const location = useLocation();
  const navigate = useNavigate();

  const state = (location.state as LocationState | null) ?? {};
  const customerName = state.customerName;

  if (!customerName) {
    return <Navigate to='/coordinate' replace />;
  }

  return (
    <Page>
      <Page.Content>
        <Container>
          <Headline>Coordination Request Submitted</Headline>
          <SuccessBanner>
            <CircleCheckIcon width={20} height={20} fill={colors.accentGreen} />
            <Body>A request was submitted to {customerName}</Body>
          </SuccessBanner>
          <Description>
            <Bold>More information is needed to coordinate this patient.</Bold> We detected missing required fields in
            the patient&apos;s file and have automatically sent a request to the provider to review and update the
            patient&apos;s information.
          </Description>
          <Button onClick={() => navigate('/coordinate')}>Back to Coordinate</Button>
        </Container>
      </Page.Content>
    </Page>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  padding-top: 40px;
  max-width: 720px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
`;

const Headline = styled.h1`
  font-size: 20px;
  font-weight: var(--font-weight-bold);
  color: ${({ theme }) => theme.colors.primaryBlue};
  margin: 0;
`;

const SuccessBanner = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  height: 64px;
  background-color: ${({ theme }) => theme.colors.accentGreen10};
  border-radius: 4px;
  padding: 0 48px;
`;

const Description = styled.p`
  font-size: 14px;
  line-height: 22px;
  margin: 0;
`;

const Bold = styled.span`
  font-weight: var(--font-weight-bold);
`;
